import Config from '../config';
import { ua, ENUM_PLATFORM_V1, ENUM_SHARE_CALLBACK_PLATFORM_V0, ENUM_PLATFORM_V0_IOS, ENUM_PLATFORM_V0_ANDROID } from '../constants/constant';
export var compareVersions = function (v1, v2) {
    if (v1 === v2) {
        return 0;
    }
    var v1parts = v1.split('.');
    var v2parts = v2.split('.');
    var len = Math.min(v1parts.length, v2parts.length);
    for (var i = 0; i < len; i++) {
        if (parseInt(v1parts[i]) > parseInt(v2parts[i])) {
            return 1;
        }
        if (parseInt(v1parts[i]) < parseInt(v2parts[i])) {
            return -1;
        }
    }
    if (v1parts.length > v2parts.length) {
        return 1;
    }
    if (v1parts.length < v2parts.length) {
        return -1;
    }
    return 0;
};
export var getAppKey = function () {
    var UA_REGEX = /\s+(YuanTiKu|YuanFuDao|YuanSouTi|YuanSouTiKouSuan)\/(\d+\.\d+\.\d+)(\s+|$)/i;
    var matches = ua.match(UA_REGEX);
    return matches ? matches[1] : '';
};
export var isIOS = function () {
    return /iP(hone|od|ad)/.test(ua);
};
export var isAndroid = function () {
    return /Android/.test(ua);
};
export var getAppVersion = function () {
    var UA_REGEX = /\s+(YuanTiKu|YuanFuDao|YuanSouTi|YuanSouTiKouSuan)\/(\d+\.\d+\.\d+)(\s+|$)/i;
    var matches = ua.match(UA_REGEX);
    return matches ? matches[2] : '';
};
export var greaterThanOrEqualTo = function (version) {
    return compareVersions(getAppVersion(), version) >= 0;
};
export var params2query = function (params) {
    var paramsList = [];
    Object.keys(params).forEach(function (key) {
        if (key && params[key]) {
            paramsList.push(key + "=" + encodeURIComponent(params[key]));
        }
    });
    if (paramsList.length) {
        return "?" + paramsList.join('&');
    }
    else {
        return '';
    }
};
export var getShareInfoUrl = function (shareInfoJson, type) {
    return Config.SOLAR_HOST + "/wenan/" + type + params2query(shareInfoJson);
};
export var shareCallbackV0ToV1 = function (v0) {
    return ENUM_PLATFORM_V1[ENUM_SHARE_CALLBACK_PLATFORM_V0[v0]];
};
export var isYuanKouSuan = function () {
    return /YuanSouTiKouSuan/i.test(ua);
};
export var isYuanSouTi = function () {
    return !isYuanKouSuan() && /YuanSouTi/i.test(ua);
};
export var isYuanFuDao = function () {
    return /YuanFuDao|YuanTiKuEmbed/i.test(ua);
};
export var isYuanTiKu = function () {
    return /YuanTiKu/i.test(ua) && !/YuanTiKuEmbed/i.test(ua);
};
export var getDefaultShareText = function () {
    if (isYuanSouTi()) {
        return {
            title: '小猿搜题',
            description: '拍一下就学会',
            text: '拍一下就学会',
        };
    }
    else if (isYuanKouSuan()) {
        return {
            title: '小猿口算',
            description: '1秒检查口算',
            text: '1秒检查口算',
        };
    }
    else if (isYuanTiKu()) {
        return {
            title: '猿题库',
            description: '从此爱上练习',
            text: '从此爱上练习',
        };
    }
    else if (isYuanFuDao()) {
        return {
            title: '猿辅导',
            description: '孩子喜欢老师好 网课就上猿辅导',
            text: '孩子喜欢老师好 网课就上猿辅导',
        };
    }
    return {};
};
export var getShareImagePreviewUrl = function (imageUrl) {
    if (imageUrl === void 0) { imageUrl = ''; }
    return Config.LEO_HOST + "/common/share-image?imageUrl=" + encodeURIComponent(imageUrl);
};
export var createCookie = function (name, value, days) {
    var expires = '';
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + value + expires + '; path=/';
};
export var readCookie = function (name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
            return c.substring(nameEQ.length, c.length);
        }
    }
    return '';
};
export var setItem = function (key, data) {
    var storageKey = '__local_' + key;
    if (!data) {
        return;
    }
    if (localStorage) {
        try {
            localStorage.setItem(storageKey, JSON.stringify(data));
        }
        catch (e) {
            console.warn("failed to setItem to localStorage, key=" + storageKey, e);
        }
    }
    else {
        createCookie(storageKey, JSON.stringify(data), 7);
    }
};
export var base64ToString = function (b64) {
    b64 = String(b64)
        .replace(/[-_]/g, function (m0) { return m0 === '-' ? '+' : '/'; })
        .replace(/[^A-Za-z0-9+/]/g, '');
    return (new Buffer(b64, 'base64')).toString();
};
export var getItem = function (key) {
    var storageKey = '__local_' + key;
    if (localStorage) {
        try {
            var data = localStorage.getItem(storageKey);
            return data ? JSON.parse(data) : '';
        }
        catch (e) {
            console.warn("failed to getItem from localStorage, key=" + storageKey, e);
            return '';
        }
    }
    else {
        return readCookie(storageKey);
    }
};
export var v0ToV1 = function (v0) {
    if (isIOS()) {
        return ENUM_PLATFORM_V1[ENUM_PLATFORM_V0_IOS[v0]];
    }
    else {
        return ENUM_PLATFORM_V1[ENUM_PLATFORM_V0_ANDROID[v0]];
    }
};
export var v0ListToV1 = function (v0List) {
    if (isIOS()) {
        return v0List.map(function (v0) { return v0ToV1(v0); }).filter(function (v0) { return !!v0; });
    }
    else {
        return v0List.map(function (v0) { return v0ToV1(v0); }).filter(function (v0) { return !!v0; });
    }
};
export var v1ToV0 = function (v1) {
    var ENUM_PLATFORM_V0 = isIOS() ? ENUM_PLATFORM_V0_IOS : ENUM_PLATFORM_V0_ANDROID;
    return ENUM_PLATFORM_V0[ENUM_PLATFORM_V1[v1]];
};
export var dispatchEvent = function (eventName, args) {
    if (args === void 0) { args = ''; }
    var event = new CustomEvent(eventName);
    event.initCustomEvent(eventName, true, true, args);
    document.body.dispatchEvent(event);
};
